<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- 遮罩 -->
    <div class="absolute inset-0 bg-black/50" @click="$emit('close')"></div>

    <!-- 模态框 -->
    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md mx-4" style="animation: slideIn 0.2s ease-out;">
      <!-- 头部 -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200">
        <h3 class="text-lg font-semibold text-slate-900">{{ category ? '编辑分类' : '新增分类' }}</h3>
        <button
          @click="$emit('close')"
          class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- 表单 -->
      <div class="p-6 space-y-4">
        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">
            分类编码 <span class="text-red-500">*</span>
          </label>
          <input
            v-model="form.code"
            type="text"
            class="form-input w-full"
            placeholder="请输入分类编码"
          >
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">
            分类名称 <span class="text-red-500">*</span>
          </label>
          <input
            v-model="form.name"
            type="text"
            class="form-input w-full"
            placeholder="请输入分类名称"
          >
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">父分类</label>
          <el-select
            v-model="form.parentId"
            class="form-select w-full"
          >
            <el-option label="无（顶级分类）" :value="null" />
            <el-option
              v-for="cat in availableParents"
              :key="cat.id"
              :label="cat.name"
              :value="cat.id"
            />
          </el-select>
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">分类图标</label>
          <input
            v-model="form.icon"
            type="text"
            class="form-input w-full"
            placeholder="请输入图标路径或SVG代码"
          >
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">排序</label>
          <input
            v-model.number="form.sort"
            type="number"
            class="form-input w-full"
            placeholder="数字越小越靠前"
          >
        </div>

        <div>
          <label class="block text-sm font-medium text-slate-700 mb-1">描述</label>
          <textarea
            v-model="form.description"
            rows="3"
            class="form-textarea"
            placeholder="请输入分类描述"
          ></textarea>
        </div>
      </div>

      <!-- 底部 -->
      <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
        <button
          @click="$emit('close')"
          class="btn-secondary"
        >
          取消
        </button>
        <button
          @click="handleSave"
          class="btn-primary"
        >
          确定
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  category: {
    type: Object,
    default: null
  },
  categories: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close', 'save'])

const form = reactive({
  code: '',
  name: '',
  parentId: null,
  icon: '',
  sort: 0,
  description: ''
})

// 可选的父分类（排除自己及其子分类）
const availableParents = computed(() => {
  if (!props.category) return props.categories

  const excludeIds = new Set()
  function collectIds(cat) {
    excludeIds.add(cat.id)
    if (cat.children) {
      cat.children.forEach(collectIds)
    }
  }
  collectIds(props.category)

  return props.categories.filter(cat => !excludeIds.has(cat.id))
})

onMounted(() => {
  if (props.category) {
    form.code = props.category.code || ''
    form.name = props.category.name || ''
    form.parentId = props.category.parentId || null
    form.icon = props.category.icon || ''
    form.sort = props.category.sort || 0
    form.description = props.category.description || ''
  }
})

function handleSave() {
  if (!form.code.trim()) {
    ElMessage.warning('请输入分类编码')
    return
  }
  if (!form.name.trim()) {
    ElMessage.warning('请输入分类名称')
    return
  }

  emit('save', {
    code: form.code,
    name: form.name,
    parentId: form.parentId || null,
    icon: form.icon || null,
    sort: form.sort || 0,
    description: form.description || null
  })
}
</script>

<style scoped>
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
